module.exports = __webpack_public_path__ + "img/front rise.2a38c4fc.png";